import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const CheckEmail = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "sign-up-check-email" */ './hocs')),
});
